import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

// export const getPriceList: any = createAsyncThunk<any>(
//     'getPriceList', async (data: any, { rejectWithValue }) => {
//         try {
//             const response = await httpService.get('/tenant-portal/price-list', {
//                 params: data
//             });
//             return response.data;
//         } catch (error: any) {
//             console.log(error?.response?.data, 7171)
//             return rejectWithValue(error?.response?.data)
//         }
//     }
// )
export const checkExternalId: any = createAsyncThunk<any>(
	'checkExternalId',
	async (data: any) => {
		const response = await httpService.get(
			`/tenant-portal/customer/checkExternalId`,
			{ params: data }
		);
		return response.data.data;
	}
);
export const getPriceList: any = createAsyncThunk<any>(
	'getPriceList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('productService/masterData/price', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getCustomerList: any = createAsyncThunk<any>(
	'getCustomerList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/tenant-portal/customers', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getCustomerAppList: any = createAsyncThunk<any>(
	'getCustomerAppList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/tenant-portal/customers', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addCustomer: any = createAsyncThunk<any>(
	'addCustomer',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post('/tenant-portal/customer', data);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getCustomerDetails: any = createAsyncThunk<any>(
	'getCustomerDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/tenant-portal/customer', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editCustomer: any = createAsyncThunk<any>(
	'editCustomer',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('/tenant-portal/customer', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateCustomerStatus: any = createAsyncThunk<any>(
	'updateCustomerStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(`/tenant-portal/customers`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);

export const updateCustomerSelectedData: any = createAsyncThunk<any>(
	'updateCustomerSelectedData',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post(`/tenant-portal/customers`, data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const addCustomerDevice: any = createAsyncThunk<any>(
	'addCustomerDevice',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/tenant-portal/customer-device-access',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteCustomerDevice: any = createAsyncThunk<any>(
	'deleteCustomerDevice',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/tenant-portal/customer-device-access',
				{ data: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteCustomer: any = createAsyncThunk<any>(
	'deleteCustomer',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete('/tenant-portal/customer', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateCustomerAppAccess: any = createAsyncThunk<any>(
	'updateCustomerAppAccess',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/tenant-portal/customerAppAccess`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);